import { useEffect, useRef, useState } from 'react';
import { stats } from '../data/siteData.js';
import useReducedMotion from '../hooks/useReducedMotion.js';

function Counter({ value, suffix }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (reducedMotion) {
      setDisplay(value);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        const startedAt = performance.now();
        const duration = 1100;

        const animate = (time) => {
          const progress = Math.min((time - startedAt) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          setDisplay(Math.round(value * eased));
          if (progress < 1) requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
        observer.disconnect();
      },
      { threshold: 0.4 },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [reducedMotion, value]);

  return (
    <strong ref={ref}>
      {display}
      {suffix}
    </strong>
  );
}

export default function Stats() {
  return (
    <section className="stats-section" id="statisztikak" aria-label="A szolgáltatás fő jellemzői">
      <div className="container stats-grid">
        {stats.map((stat) => (
          <article className="stat-item" key={stat.label}>
            <Counter value={stat.value} suffix={stat.suffix} />
            <span>{stat.label}</span>
          </article>
        ))}
      </div>
    </section>
  );
}
